(function ($) {

  if($('.slider-member-story').length){
    const slider = $('.slider-member-story');
    const parent = slider.closest('.section--slider-member-story');
    slider.slick({
      arrows: false,
      infinite: false
    });

    slider.on('afterChange', function (event, slick, nextSlide) {
      updateprogressbar(nextSlide, parent);
    });

    parent.find('.slider-next').click(function (e) {
      e.preventDefault();
      slider.slick('slickNext');
    });

    parent.find('.slider-prev').click(function (e) {
      e.preventDefault();
      slider.slick('slickPrev');
    });
  }


  function updateprogressbar(nextSlide, wrapper) {

    let index = parseInt(nextSlide) + 1;
    let totalSlide = wrapper.find('.slick-track > div').length;
    let progress = (index / totalSlide) * 100;

    wrapper.find('.slider-progress').width(progress + '%');
    wrapper.find('.slider-current-index').html(index < 10 ? '0' + index : index);
  }

})(jQuery);
